import { Box, Container } from '@mui/material';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';

interface Props {
  helmetPageTitle: string;
  children: React.ReactNode;
  fillAvailableHeight?: boolean;
}

export const PageContainer: FC<Props> = ({
  children,
  helmetPageTitle,
  fillAvailableHeight = false,
}) => {
  return (
    <>
      <Helmet>
        <title>{helmetPageTitle}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: fillAvailableHeight ? 'flex' : undefined,
          flexDirection: fillAvailableHeight ? 'column' : undefined,
          flexGrow: 1,
        }}>
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: fillAvailableHeight ? 1 : undefined,
            height: fillAvailableHeight ? undefined : '100%',
          }}>
          {children}
        </Container>
      </Box>
    </>
  );
};
